import styled, { css } from 'styled-components';
import { mediaMixin, token } from '@zillow/constellation';

export const StyledTourCardContainer = styled.div<{ size: string; isSelected: boolean; hasBigBottomBorder: boolean }>(
  ({ size, isSelected, hasBigBottomBorder }) => css`
    max-width: 300px;
    display: flex;
    flex-direction: column;
    border: 1px solid ${token('colors.gray300')};
    margin-bottom: 2px;

    ${hasBigBottomBorder &&
    css`
      border-bottom: 3px solid ${token('colors.blue400')};
      margin-bottom: 0px;
    `}

    ${size === 'md' &&
    css`
      max-width: 272px;
      ${mediaMixin(
        'lg',
        css`
          width: 320px;
        `,
      )}
    `}

    ${isSelected &&
    css`
      box-shadow: 0 0 12px 0 rgba(0, 0, 0, 0.2);
    `}
  `,
);
